<!-- 1.1 Erreurs d'acheminement -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-route"></i> Taux d'erreurs d'acheminement</h3>
    <span class="periode-info" *ngIf="erreurs">{{ erreurs.periodeDebut | date:'dd/MM/yy' }} → {{ erreurs.periodeFin | date:'dd/MM/yy' }}</span>
  </div>
  <div *ngIf="chargement.erreurs" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.erreurs && erreurs">
    <div class="grille-kpi">
      <div class="kpi kpi-danger"><div class="kpi-label">Taux d'erreurs</div><div class="kpi-valeur">{{ erreurs.tauxPct }} %</div></div>
      <div class="kpi"><div class="kpi-label">Erreurs constatées</div><div class="kpi-valeur">{{ erreurs.nbErreurs }}</div></div>
      <div class="kpi kpi-primary"><div class="kpi-label">Total commandes</div><div class="kpi-valeur">{{ erreurs.totalCommandes }}</div></div>
    </div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:18px;">
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Évolution mensuelle</h4>
        <div echarts [options]="optErreursEvolution" class="chart-container" style="height:260px"></div>
      </div>
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Top 5 trajets erronés</h4>
        <div echarts [options]="optErreursTopTrajets" class="chart-container" style="height:260px"></div>
      </div>
    </div>
    <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:16px 0 8px;">Dernières erreurs</h4>
    <table class="table-rapport" *ngIf="erreurs.detail?.length; else videErreurs">
      <thead><tr><th>N° commande</th><th>Type</th><th>Date</th><th>Livreur</th><th>Statut</th></tr></thead>
      <tbody>
        <tr *ngFor="let r of erreurs.detail">
          <td>{{ r.numeroCommande }}</td>
          <td>{{ r.type }}</td>
          <td>{{ r.dateIncident | date:'dd/MM/yy HH:mm' }}</td>
          <td>{{ r.livreur || '—' }}</td>
          <td>{{ r.statut }}</td>
        </tr>
      </tbody>
    </table>
    <ng-template #videErreurs><div class="vide"><i class="fal fa-check-circle"></i> Aucune erreur sur la période</div></ng-template>
  </ng-container>
</div>

<!-- 1.2 Pertes & vols -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-exclamation-triangle"></i> Taux de pertes &amp; vols</h3>
    <span class="periode-info" *ngIf="pertes">{{ pertes.periodeDebut | date:'dd/MM/yy' }} → {{ pertes.periodeFin | date:'dd/MM/yy' }}</span>
  </div>
  <div *ngIf="chargement.pertes" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.pertes && pertes">
    <div class="grille-kpi">
      <div class="kpi kpi-danger"><div class="kpi-label">Taux global</div><div class="kpi-valeur">{{ pertes.tauxPct }} %</div></div>
      <div class="kpi"><div class="kpi-label">Pertes</div><div class="kpi-valeur">{{ pertes.nbPertes }}</div></div>
      <div class="kpi"><div class="kpi-label">Vols</div><div class="kpi-valeur">{{ pertes.nbVols }}</div></div>
      <div class="kpi kpi-warn"><div class="kpi-label">Montant remboursé</div><div class="kpi-valeur">{{ pertes.montantTotalPertes | number }} F</div></div>
    </div>
    <div echarts [options]="optPertesEvolution" class="chart-container" style="height:260px"></div>
    <table class="table-rapport" *ngIf="pertes.detail?.length" style="margin-top:14px;">
      <thead><tr><th>N° commande</th><th>Type</th><th>Date</th><th>Livreur</th><th>Montant</th></tr></thead>
      <tbody>
        <tr *ngFor="let r of pertes.detail">
          <td>{{ r.numeroCommande }}</td>
          <td>{{ r.type }}</td>
          <td>{{ r.dateIncident | date:'dd/MM/yy' }}</td>
          <td>{{ r.livreur || '—' }}</td>
          <td>{{ (r.montantRemboursement || 0) | number }} F</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>

<!-- 1.3 Colis endommagés -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-box-open"></i> Colis endommagés</h3>
    <div style="display:flex;gap:10px;align-items:center;">
      <select class="filtre-inline" [(ngModel)]="filtrePriorite" (change)="charger()" style="height:30px;padding:0 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;">
        <option [ngValue]="null">Toutes priorités</option>
        <option value="BASSE">Basse</option>
        <option value="MOYENNE">Moyenne</option>
        <option value="HAUTE">Haute</option>
        <option value="CRITIQUE">Critique</option>
      </select>
      <span class="periode-info" *ngIf="dommages">{{ dommages.periodeDebut | date:'dd/MM/yy' }} → {{ dommages.periodeFin | date:'dd/MM/yy' }}</span>
    </div>
  </div>
  <div *ngIf="chargement.dommages" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.dommages && dommages">
    <div class="grille-kpi">
      <div class="kpi kpi-warn"><div class="kpi-label">% endommagés</div><div class="kpi-valeur">{{ dommages.tauxPct }} %</div></div>
      <div class="kpi"><div class="kpi-label">Nombre</div><div class="kpi-valeur">{{ dommages.nbEndommages }}</div></div>
      <div class="kpi kpi-danger"><div class="kpi-label">Coût des dommages</div><div class="kpi-valeur">{{ dommages.montantTotalDommages | number }} F</div></div>
    </div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:18px;">
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Évolution mensuelle</h4>
        <div echarts [options]="optDommagesEvolution" class="chart-container" style="height:260px"></div>
      </div>
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Par priorité</h4>
        <div echarts [options]="optDommagesParPriorite" class="chart-container" style="height:260px"></div>
      </div>
    </div>
  </ng-container>
</div>

<!-- 1.4 Taux de réclamations -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-comment-exclamation"></i> Taux de réclamations</h3>
    <span class="periode-info" *ngIf="reclamations">{{ reclamations.periodeDebut | date:'dd/MM/yy' }} → {{ reclamations.periodeFin | date:'dd/MM/yy' }}</span>
  </div>
  <div *ngIf="chargement.reclamations" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.reclamations && reclamations">
    <div class="grille-kpi">
      <div class="kpi kpi-warn"><div class="kpi-label">Taux</div><div class="kpi-valeur">{{ reclamations.tauxPct }} %</div></div>
      <div class="kpi"><div class="kpi-label">Réclamations</div><div class="kpi-valeur">{{ reclamations.nbReclamations }}</div></div>
      <div class="kpi kpi-primary"><div class="kpi-label">Commandes total</div><div class="kpi-valeur">{{ reclamations.totalCommandes }}</div></div>
    </div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:18px;">
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Top motifs</h4>
        <div echarts [options]="optReclamationsTopMotifs" class="chart-container" style="height:260px"></div>
      </div>
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Évolution mensuelle</h4>
        <div echarts [options]="optReclamationsEvolution" class="chart-container" style="height:260px"></div>
      </div>
    </div>
  </ng-container>
</div>
